<script>
  export let msg;
</script>

<div>{msg}</div>

<style>
  div {
    color: black;
  }
</style>
